import { Component, Injector, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef, DialogService } from 'primeng/dynamicdialog';
import { FormGenerico } from '../formgenerico/formgenerico';
import { FormAdiantamentoGenericoComponent } from '../formadiantamentogenerico/formadiantamentogenerico.component';
import { Observable, of } from 'rxjs';

@Component({
  selector: 'app-lista-adiantamentos-generico',
  templateUrl: './listaadiantamentosgenerico.component.html',
})
export class ListaAdiantamentosGenericoComponent extends FormGenerico<any> implements OnInit {

  objSel: any = {};
  mode: 'inline' | 'detail' = 'inline';
  listaAdiantamentos: any[] = [];
  carregando = false;

  // Detail mode specific
  detailService: any = null;
  loadListFn: (empresaId: number, parentId: number) => Observable<any[]>;

  // Inline mode specific
  totalField = 'totalAdiantam';
  totalMoedaField = 'totalAdiantamMoeda';
  obsField = 'obs';
  regraId = 628;

  constructor(
    injectorObj: Injector,
    public refDialog: DynamicDialogRef,
    public config: DynamicDialogConfig,
    public dialogService: DialogService,
  ) {
    super(injectorObj, config.data.apiService);
  }

  override ngOnInit(): void {
    if (!this.config.data?.objSel) {
      this.refDialog.close();
      return;
    }

    this.objSel = this.config.data.objSel;
    this.mode = this.config.data.mode || 'inline';
    this.regraId = this.config.data.regraId || 628;

    if (this.mode === 'inline') {
      this.totalField = this.config.data.totalField || 'totalAdiantam';
      this.totalMoedaField = this.config.data.totalMoedaField || 'totalAdiantamMoeda';
      this.obsField = this.config.data.obsField || 'obs';
    } else {
      this.detailService = this.config.data.detailService;
      this.loadListFn = this.config.data.loadListFn;
    }

    this.carregar();
  }

  carregar(): void {
    this.carregando = true;

    if (this.mode === 'inline') {
      // Inline mode: retrieve parent again to get updated values
      this.api.findById(this.auth.empresa.id, this.objSel.id).subscribe({
        next: (res: any) => {
          this.objSel = res;
          const valor = res[this.totalField] || 0;
          const valorMoeda = res[this.totalMoedaField] || 0;
          const obs = res[this.obsField] || '';
          
          this.listaAdiantamentos = [{
            valor,
            valorMoeda,
            obs,
            fatorMoeda: res.fatorMoeda
          }];

          if (res.fatorMoeda?.id && (!res.fatorMoeda.fator || !res.fatorMoeda.moeda)) {
            const fmoService = this.globalFunctions.returnApi('FatorMoeda');
            if (fmoService) {
              fmoService.findById(this.auth.empresa.id, res.fatorMoeda.id).subscribe({
                next: (fmo: any) => {
                  this.listaAdiantamentos[0].fatorMoeda = fmo;
                }
              });
            }
          }
          this.carregando = false;
        },
        error: err => {
          this.carregando = false;
          this.errorHandler.handle(err);
        }
      });
    } else {
      // Detail mode
      if (this.loadListFn) {
        this.loadListFn(this.auth.empresa.id, this.objSel.id).subscribe({
          next: (lista: any[]) => {
            this.listaAdiantamentos = lista || [];
            this.carregando = false;
          },
          error: err => {
            this.carregando = false;
            this.errorHandler.handle(err);
          }
        });
      } else {
        this.carregando = false;
      }
    }
  }

  inserirNovoAdiantamento(): void {
    const titulo = 'Inserir Adiantamento Financeiro - Código ' + (this.objSel.numOs || this.objSel.id);
    const ref = this.dialogService.open(FormAdiantamentoGenericoComponent, {
      header: titulo,
      width: '560px',
      height: 'auto',
      data: {
        objSel: this.objSel,
        apiService: this.api,
        mode: this.mode,
        regraId: this.regraId,
        totalField: this.totalField,
        totalMoedaField: this.totalMoedaField,
        obsField: this.obsField,
        detailService: this.detailService,
        className: this.config.data.className
      }
    });

    ref.onClose.subscribe((atualizado: boolean) => {
      if (atualizado) { this.carregar(); }
    });
  }

  editarAdiantamento(adiant: any): void {
    const titulo = 'Editar Adiantamento - Código ' + (this.objSel.numOs || this.objSel.id);
    const ref = this.dialogService.open(FormAdiantamentoGenericoComponent, {
      header: titulo,
      width: '560px',
      height: 'auto',
      data: {
        objSel: this.objSel,
        apiService: this.api,
        mode: this.mode,
        regraId: this.regraId,
        totalField: this.totalField,
        totalMoedaField: this.totalMoedaField,
        obsField: this.obsField,
        detailService: this.detailService,
        detailObj: adiant,
        className: this.config.data.className
      }
    });

    ref.onClose.subscribe((atualizado: boolean) => {
      if (atualizado) { this.carregar(); }
    });
  }

  sair(): void {
    this.refDialog.close(false);
  }

  override dataExtraObj(res: any): void {}
  protected override onPropertyChange(propName: string, newValue: any): void {}
}
